import * as React from "react";

function Placeholder() {

	return (
		<div className="c-section c-section--alt c-section--wishlist-cards">
			<div className="c-section__inner">
				<div className="c-grid c-grid--five-col">
					<div className="c-product__wishlist-placeholder"></div>
					<div className="c-product__wishlist-placeholder"></div>
					<div className="c-product__wishlist-placeholder"></div>
					<div className="c-product__wishlist-placeholder"></div>
					<div className="c-product__wishlist-placeholder"></div>
				</div>
			</div>
		</div>
	);
}

export default Placeholder;
